export const ITEM_KINDS = [
  { value: "appearance", label: "Court appearance" },
  { value: "hourly", label: "Hourly engagement" },
  { value: "drafting", label: "Drafting" },
  { value: "conference", label: "Conference / advice" },
  { value: "opinion", label: "Written opinion" },
  { value: "retainer", label: "Retainer" },
  { value: "disbursement", label: "Disbursement" },
  { value: "other", label: "Other professional service" },
];

export const KIND_LABEL = ITEM_KINDS.reduce(
  (acc, k) => ({ ...acc, [k.value]: k.label }),
  {},
);

export const STATUS_FILTERS = [
  { value: "all", label: "All" },
  { value: "open", label: "Outstanding" },
  { value: "draft", label: "Draft" },
  { value: "sent", label: "Sent" },
  { value: "partial", label: "Part paid" },
  { value: "overdue", label: "Overdue" },
  { value: "paid", label: "Paid" },
  { value: "written_off", label: "Written off" },
  { value: "cancelled", label: "Cancelled" },
];

export const BUCKET_LABELS = {
  current: "Not yet due",
  d1_30: "1-30 days",
  d31_60: "31-60 days",
  d61_90: "61-90 days",
  d90_plus: "90+ days",
};

export const thisMonth = () => new Date().toISOString().slice(0, 7);

export const money = (value, symbol = "Rs.") =>
  `${symbol} ${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const compact = (value, symbol = "Rs.") => {
  const n = Number(value || 0);
  if (Math.abs(n) >= 10000000) return `${symbol} ${(n / 10000000).toFixed(2)} Cr`;
  if (Math.abs(n) >= 100000) return `${symbol} ${(n / 100000).toFixed(2)} L`;
  return money(n, symbol);
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const addDays = (iso, days) => {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + Number(days || 0));
  return d.toISOString().slice(0, 10);
};
